// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__16LR7","title":"styles_title__2jhFB","close-modal":"styles_close-modal__1J4SI"};